import React, { useEffect, useState, useMemo } from 'react';
import { useParams, useSearchParams} from 'react-router-dom';
import { useDetalleSolicitudModel } from '../../../modelos/Solicitudes/modeloSolicitud'; 
import { useContabilidadModel } from '../../../modelos/Contabilidad/modeloContabilidad'; 
import { formatearFechaCompleta } from '../../../utils/utils'; 
import { useUsers } from '../../../metodos/userContext';
import { 
  Copy, 
  Video,
  KeyRound,
  Check,
  UserCheck, 
  FileCheck, 
  Bell, 
  DollarSign, 
  RotateCcw, 
  Eye, 
  AlertTriangle,
  FileText,
  AlertCircle,
  Settings,
  CheckCircle,
  XCircle,
  Send,
} from 'lucide-react';
import { useListasModel } from '../../../modelos/listas/modeloListas';
import useClientesModel from '../../../modelos/Clientes/modeloClientes';
import { useTutoresModel } from '../../../modelos/Tutores/modeloTutores';
import { obtenerNombreEmpresaReal, useisUserAdmin, useisUserCliente, useisUserTutor } from '../../../config/unificacion';
import HeaderServicios from './vistas/HeaderServicios';
import { useDialog } from '../../../components/Dialogs/Dialogprovider';
import ErrorWidget from '../../../components/Loadings/ErrorWidget';
import AdminViewServicio from './vistas/AdminView';
import TutorViewServicio from './vistas/TutorView';
import ClienteViewServicio from './vistas/ClienteView';

const DetallesServicio = ({ publicView = false }) => {
    const { nombreEmpresa, codigo} = useParams();
    let nombreEmpresaReal =  obtenerNombreEmpresaReal(nombreEmpresa);
    const [searchParams, setSearchParams] = useSearchParams();
    
    const [servicioListo, setServicioListo] = useState(false);
    const [solicitudCargada, setSolicitudCargada] = useState(false);
    const [formData, setFormData] = useState({
      trabajos: [],
      comentarioEntrega : "",
    });

    const dialogs = useDialog();

    const {usuario} = useUsers();
    const {materiasOptions, cargarMaterias} = useListasModel();

    //ROLES
    const isAdmin = useisUserAdmin(usuario);
    const isTutor = useisUserTutor(usuario);
    const isCliente = useisUserCliente(usuario,publicView);


    //listas
    const {tutoresOptions, cargarTutores} = useTutoresModel();

    //cargar tutores
    useEffect(() =>{
      cargarTutores();
    },[]);
    
    //cargar materias
    useEffect(() =>{
      cargarMaterias();
    },[]);

    const {
        solicitud,
        loadingSolicitudes,
        errorSolicitudes,
        cargarSolicitudPorId,
    } = useDetalleSolicitudModel();

    const {
        servicio,
        loadingServicios,
        errorServicios,
        cargarServicioPorCodigo,
        entregarTrabajoTutor,
        setupWebSocketsServicios,
        updateServicio,
    } = useContabilidadModel();

    const {
          cliente,
          loadingClientes,
          getCliente,
          busquedaClientesOptions,
          handleInputChange,
    } = useClientesModel();

    //tabs que son visibles
    //tener en cuenta materia == TESIS, faltan demas cosas
    const visibleTabs = useMemo(() => {
      if (!servicio) return [];

      const notificaciones = {

        preguntas: servicio.preguntas.length || 0,
        
        revision: servicio.revision?.activo || 0,
        
        entregas: servicio.entregasTrabajo.length || 0,
        
        pagos: servicio.pagos.length || 0,

      }

      let baseTabs;

      if(isAdmin){
        baseTabs = [
            {id: 'general', label: 'General', icon: FileText },
            {id: 'tesis', label: 'Tesis', icon: DollarSign }, 
            {id: 'pagos', label: 'Registrar pagos', icon: DollarSign, count: notificaciones.pagos},    
            {id: 'entregas', label: 'Entregas / Avances', icon: DollarSign, count: notificaciones.entregas},
            {id: 'historial', label: 'Historial', icon: Eye},
            {id: 'preguntas', label: 'preguntas', icon: DollarSign, count: notificaciones.preguntas}, 
            {id: 'revision', label: 'Revision', icon: DollarSign, count: notificaciones.revision}, 
        ];
      } else if ( isTutor){
        baseTabs = [
            { id: 'general', label: 'General', icon: FileText },
            { id: 'preguntas', label: 'Preguntas', icon: Settings },
            { id: 'tesis', label: 'Tesis', icon: Settings },
            { id: 'entregas', label: 'Entregas / Avances', icon: CheckCircle },
            { id: 'revision', label: 'Revision', icon: CheckCircle },
        ];
      }else if (isCliente){
        baseTabs = [
            { id: 'general', label: 'General', icon: FileText },
            { id: 'entregas', label: 'Entregas / Avances', icon: CheckCircle },
            { id: 'revision', label: 'Revision', icon: CheckCircle },
        ];
      }
        
        // 2. Si el servicio no ha cargado, no muestra nada
        if (!servicio) {
            return [];
        }

        // 3. Aplica los filtros que necesitas
        return baseTabs.filter(tab => {
            // Muestra la pestaña 'Tesis' solo si el servicio es de tipo 'TESIS'
            if (tab.id === 'tesis') {
                return servicio.materia === 'TESIS';
            }
            // Muestra la pestaña 'Entregas' solo si ya hay entregas registradas
            if (tab.id === 'entregas' && !isAdmin) {
                return servicio.entregasTrabajo?.length > 0;
            }

            if (tab.id === 'revision' && !isAdmin) {
                return servicio.revision.activo;
            }
            // La pestaña 'General' y otras que no tengan condición, siempre se muestran
            return true;
        });

    }, [servicio , isAdmin]); 

    const activeTab = useMemo(() => {
      const tabParam = searchParams.get('view');

      const isValidTab = visibleTabs.some(t => t.id === tabParam);

      return isValidTab ? tabParam : 'general';
    }, [searchParams, visibleTabs]);

    const handleTabChange = (tabId) => {
      setSearchParams({ view: tabId });
    }

    // cargar servicio por codigo
    useEffect(() => {
        // Si el servicio ya se cargó o está cargando, no hacer nada
        if (servicioListo ) {
        return;
        }

        let socketCleanup = null;
        
        const cargarServicio = async () => {
            try {
                console.log("Cargando servicio con código:", codigo ,nombreEmpresa);
                const servicioObjeto = await cargarServicioPorCodigo(nombreEmpresaReal,codigo);

                if(servicioObjeto){
                  socketCleanup = setupWebSocketsServicios(servicioObjeto, nombreEmpresaReal);
                }

                setServicioListo(true);
            } catch (error) {
                console.error("Error al cargar el servicio:", error);
                setServicioListo(false);
            }
        };

        console.log("el codigo es",codigo);
        
        if (codigo) {
            cargarServicio();
        }

        // Cleanup function
        return () => {
            if (socketCleanup) {
                socketCleanup();
            }
        };

    }, [codigo, cargarServicioPorCodigo, loadingServicios]);

    
    // cargar solicitud cuando servicio este listo
    useEffect(() => {
        // Si ya se cargó la solicitud o el servicio no está listo, salir
        if (solicitudCargada || !servicioListo || !servicio) {
        return;
        }
        
        const cargarSolicitud = async () => {
        if (servicio.idsolicitud) {
            try {
            console.log("Cargando solicitud con ID:", servicio.idsolicitud);
            await cargarSolicitudPorId(servicio.idsolicitud,nombreEmpresaReal);
            setSolicitudCargada(true);
            } catch (error) {
            console.error("Error al cargar la solicitud:", error);
            }
        }
        };
        
        cargarSolicitud();
    }, [servicioListo, servicio, cargarSolicitudPorId, solicitudCargada]);

    //cargar cliente xd
    useEffect(() => {
        // Función asíncrona para cargar los datos del cliente
        const cargarCliente = async () => {
            // Asegúrate de que la solicitud exista y tenga una propiedad 'cliente'
            if (solicitud && solicitud.cliente) {
                try {
                    await getCliente(nombreEmpresaReal, solicitud.cliente);
                } catch (error) {
                    console.error("Error al cargar el cliente:", error);
                }
            }
            
        };

        cargarCliente();

    }, [solicitud, nombreEmpresaReal]); // 3. EL EFECTO SE EJECUTA CUANDO 'solicitud' CAMBIA
  
    //cargas

    if (errorServicios) {
      return (
        <ErrorWidget
          titulo="Error al obtener el servicio"
          mensaje={errorServicios}
        />
      );
    }

    // Manejo de estados de carga y error
    if (loadingServicios || (servicioListo && loadingSolicitudes && loadingClientes)) {
        return (
        <div className="flex justify-center items-center h-screen">
            <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500">              
            </div>
        </div>
        );
    }
    
    if (servicioListo && errorSolicitudes) {
        return (
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative" role="alert">
            <strong className="font-bold">Error: </strong>
            <span className="block sm:inline">No se pudo cargar la solicitud. Por favor, intente nuevamente.</span>
        </div>
        );
    }
    
    // Si no hay servicio o no se ha cargado aún
    if (!servicio) {
        return (
        <div className="bg-yellow-100 border border-yellow-400 text-yellow-700 px-4 py-3 rounded relative" role="alert">
            <strong className="font-bold">Aviso: </strong>
            <span className="block sm:inline">No se encontró el servicio con el código especificado.</span>
        </div>
        );
    }

    
    const entregarTrabajo = async(e) => {
      console.log("trabajo a entregar ",formData,nombreEmpresa);
      await entregarTrabajoTutor(formData,nombreEmpresa);
      
      setFormData({
        ...formData,
        trabajos: [], // Limpiar el array de archivos
        comentarioEntrega: "" // Opcional: también limpiar comentarios
      });
      //actualizar servicio nuevamente al subir
      await cargarServicioPorCodigo(nombreEmpresa,codigo);
    }

    // Función para manejar cambios en los inputs
    const handleFormularioEntrega = (e) => {
      const { name, value } = e.target;
      setFormData({
        ...formData,
        [name]: value
      });
    };

    //acutalizar servicio
    const handleSave = async(field, value) =>{
      console.log("actualizar servivcio",field,value);

      if(field == "fechaentrega"){
        const fechaNueva = new Date(value);
        const fechaActual = new Date();

        if (fechaNueva < fechaActual) {

          const onConfirmarCambio = () => {
            console.log("Usuario confirmó fecha pasada:", field, value);
            updateServicio(servicio.codigo, nombreEmpresaReal, field, value, 'field');
            dialogs.showSuccess('Fecha de entrega actualizada correctamente.');
          };

          dialogs.showConfirm(
            `Estás asignando una fecha de entrega en el PASADO (${formatearFechaCompleta(value)}). ¿Estás seguro de que deseas continuar?`,
            onConfirmarCambio, // Callback simple
            'Advertencia de fecha' // Título
          );
          
          return;

        }
      }

      updateServicio(servicio.codigo, nombreEmpresaReal, field, value, 'field');

    }

    //actualizar tesis
    const handleSaveTesis = async(avances) =>{
      const updateTesis = {
        "calendarioAvances" : avances,
        "calendarioEnviadoACliente" : false,
      };
      //console.log("save tesis",updateTesis);
      updateServicio(servicio.codigo,nombreEmpresaReal,'objetoTesis',updateTesis,'field');
    }

    const auxiliarBusqueda = (field, selectedOption, inputValue) => {
      console.log("auxiliar busqueda",field,selectedOption,inputValue);
      handleInputChange(selectedOption);
    }

    //PREGUNTAS
    const handleEnviarPregunta = async (preguntasActualizadas) =>{

      console.log("a responder pregunta");

      await updateServicio(servicio.codigo, nombreEmpresaReal, 'preguntas', preguntasActualizadas, 'field');

    }

    return (
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 min-h-screen">
        <HeaderServicios servicio={servicio}/>

        {/* VISTA */}
        {(() => {
          if(isAdmin){
            return(
              <AdminViewServicio
                servicio={servicio}
                visibleTabs={visibleTabs}
                handleTabChange={handleTabChange}
                activeTab={activeTab}
                materiasOptions={materiasOptions}
                isAdmin={isAdmin}
                handleSave={handleSave}
                auxiliarBusqueda={auxiliarBusqueda}
                tutoresOptions={tutoresOptions}
                entregarTrabajo={entregarTrabajo}
                handleSaveTesis={handleSaveTesis}
                solicitud={solicitud}
                handleEnviarPregunta={handleEnviarPregunta}
                usuario={usuario}
                formData={formData}
                setFormData={setFormData}
              />
            );
          } else if (isTutor){
            return(
              <TutorViewServicio
                servicio={servicio}
                visibleTabs={visibleTabs}
                handleTabChange={handleTabChange}
                activeTab={activeTab}
                solicitud={solicitud}
                cliente={cliente}
                formData={formData}
                setFormData={setFormData}
                nombreEmpresaReal={nombreEmpresaReal}
                handleFormularioEntrega={handleFormularioEntrega}
                entregarTrabajo={entregarTrabajo}
                usuario={usuario}
                handleEnviarPregunta={handleEnviarPregunta}
                handleSaveTesis={handleSaveTesis}
              />
            );
          } else if (isCliente){
            return(
              <ClienteViewServicio
                servicio={servicio}
                visibleTabs={visibleTabs}
                handleTabChange={handleTabChange}
                activeTab={activeTab}
                solicitud={solicitud}
                cliente={cliente}
                nombreEmpresaReal={nombreEmpresaReal}
              />
            );
          }
           return <div className="p-10 text-center">No tienes permisos para ver este servicio.</div>;
        })()}

        
      </div>
    );

}

export default DetallesServicio
